import { App } from '@capacitor/app';
import { filter } from 'rxjs/operators';
import {Component, OnInit} from '@angular/core';
import {SubscriptionLike as ISubscription} from 'rxjs';
import {NavigationEnd, Router} from '@angular/router';
import { Platform } from '@angular/cdk/platform';
import { SplashScreen } from '@capacitor/splash-screen';

declare const window: any;
declare const gtag: Function;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  appLoader = false;
  subscription: ISubscription;
  title = 'app works!';
  constructor(private platform: Platform, private router: Router) {
    this.initApp();
    this.handleDeepLinks();
  }
  ngOnInit() {
    this.setUpAnalytics();
  }

  async initApp() {
      if (this.platform.ANDROID) {
        App.addListener('backButton', ({ canGoBack }) => {
          if (!canGoBack) {
            this.showExitConfirmation();
          } else {
            window.history.back();
          }
        });
      }
      await this.handleSplashScreen();
      //Splash Screen
    }

  setUpAnalytics() {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                gtag('config', 'G-XTFQ1BWVN6',
                    {
                        page_path: event.urlAfterRedirects
                    }
                );
            });
    }

  showExitConfirmation() {
    const shouldExit = confirm('Do you really want to exit the app?');
    if (shouldExit) {
      App.exitApp();
    }
  }

  async handleSplashScreen() {
    await SplashScreen.show({
      showDuration: 3000,
      autoHide: true
    });

    setTimeout(async () => {
      await SplashScreen.hide();
    }, 3000);
  }

  handleDeepLinks() {
    App.addListener('appUrlOpen', (data) => {
      console.log('Deep Link Opened:', data.url);
      const path = data.url.split('smartdukaan.com/')[1];
      console.log('Deep Link Path:', path);
      if (path) {
        this.router.navigate([`/${path}`]);
      }
    });
  }

}
